﻿define("registerHelper", ["jquery", "bootstrap", "registerValidation", "uiNotification", "jquery.unobtrusive-ajax", "jquery-validate", "jquery-validate-unobtrusive", "jquery.maskedinput"],
    (function ($, bs, registerValidation, uiNotification) {
        var registerHelper = {
            init: function () {
                var self = this;
                uiNotification.init();
                uiNotification.loader(false);
                registerValidation.init();

                $.getScript("https://www.google.com/recaptcha/api.js");
                window.icaptchacallback = function () {
                    $("#register").attr("disabled", false);
                }

                window.icaptcharegistrationpromtcallback = function () {
                    $("#btnCreateNewAccount").attr("disabled", false);
                }

                $("#registerForm").submit(function (event) {
                    var isValid = $('#registerForm').valid();
                    if (isValid) {
                        uiNotification.loader(true);
                    }
                });

                $(".txtPrincipalInfo").prop("type", "password");


                if ($("#Request_Password").val().length > 0) {
                    var me = $(this);
                    me.css("border-left", "2px solid red");
                }

                $("#Request_Password").on('input', function () {
                    var me = $(this);
                    var validateRequiredField = me.val() == "" ? false : true;
                    if (validateRequiredField) {
                        var filter = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*#?&.,]).{8,40}$/;
                        // var filter = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (filter.test(me.val())) {
                            me.css("border-left", "2px solid green");
                            return;
                        } else {
                            me.css("border-left", "2px solid red");
                            return;
                        }
                    }
                    me.css("border-left", "2px solid red");
                });


                $("#Request_ConfirmPassword").on('input', function () {
                    var me = $(this);
                    var validateRequiredField = me.val() == "" ? false : true;
                    if (validateRequiredField) {
                        var password = $("#Request_Password").val();
                        if (me.val() == password) {
                            me.css("border-left", "2px solid green");
                            return;
                        }
                    }
                    me.css("border-left", "2px solid red");
                });

                $("#Request_Username, #Request_Password,#Request_ConfirmPassword ").on("copy cut paste drop", function () {
                    return false;
                });

                var isKYCEnabled = ($("#hiddenIsKYCEnabled").val() === "True") ? true: false;
                if (isKYCEnabled) {

                    $("#divCertifyChanges").toggle($("#rbIncludedOnMPA").is(":checked") &&
                        $("#rbHasSignedMPA").is(":checked"));
                    $(".MPANameWarning").toggle($("#rbIncludedOnMPA").is(":checked"));
                    $("#divSignedMPA").toggle($("#rbIncludedOnMPA").is(":checked"));

                    $("input:radio[name='IncludedOnMPA']").on("click",
                        function() {
                            $("#divCertifyChanges").toggle($("#rbIncludedOnMPA").is(":checked") &&
                                $("#rbHasSignedMPA").is(":checked"));
                            $(".MPANameWarning").toggle($("#rbIncludedOnMPA").is(":checked"));
                            $("#divSignedMPA").toggle($("#rbIncludedOnMPA").is(":checked"));
                        });
                    $("input:radio[name='HasSignedMPA']").on("click",
                        function() {
                            $("#divCertifyChanges").toggle($("#rbIncludedOnMPA").is(":checked") &&
                                $("#rbHasSignedMPA").is(":checked"));
                        });

                } else {

                    $("#divChkAccountOwner").toggle($("#rbIsAccountOwner").is(":checked"));
                    $("#divNoteOnName").toggle($("#rbIsAccountOwner").is(":checked"));

                    $("input:radio[name='IsAccountOwner']").on("click", function () {
                        $("#divChkAccountOwner").toggle($("#rbIsAccountOwner").is(":checked"));
                        $("#divNoteOnName").toggle($("#rbIsAccountOwner").is(":checked"));
                    });
                }

            }

        };
        return registerHelper;
    })
)